import React from 'react';
import { Insight } from 'libs/end-to-end/src/insights';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Heading } from 'apps/sigma2-ui/src/components/ui/Heading';
import { fillArray } from 'libs/end-to-end/src/factories/fillArray';
import { LoadingSkeleton } from 'apps/sigma2-ui/src/components/LoadingSkeleton';
import { getInsightKey } from 'apps/sigma2-ui/src/pages/InsightsSection.utils';
import { sortByPriority } from 'apps/sigma2-ui/src/pages/InsightsSection.utils';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { InsightsCard } from 'apps/sigma2-ui/src/components/insights/InsightsCard';
import { useDimensionConfig } from 'apps/sigma2-ui/src/lib/hooks/useDimensionConfig';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';

export const RelatedInsights: React.FC<{
  focusArea: MyFocusAreaDefinition;
  maxInsights?: number;
  insights: Insight[];
  isLoading: boolean;
  calibrationFraming: CalibrationFraming;
}> = ({ focusArea, insights, maxInsights, isLoading, calibrationFraming }) => {
  const language = useLanguage();
  const dimensionsPayload = useDimensionConfig();

  if (!isLoading && insights.length === 0) {
    return null;
  }

  return (
    <Spacing direction="vertical" size="gap-10">
      <Heading
        level={2}
        fontFamily="font-sans"
        textColor="text-gray-1000"
        textSize="text-xl"
        fontWeight="font-black"
        className="leading-none"
      >
        {convertTranslatedContentToReactNode(language.insightRelatedInsightsHeading())}
      </Heading>

      {isLoading && (
        <Spacing
          direction="horizontal"
          size="gap-14"
          divider
          className="w-full"
        >
          {fillArray({ length: maxInsights ?? 3, valueFn: () => null }).map(
            (_, index) => {
              return (
                <LoadingSkeleton
                  heightClassName="h-96"
                  widthClassName="w-96"
                  key={index}
                />
              );
            },
          )}
        </Spacing>
      )}

      {!isLoading && (
        <Spacing direction="horizontal" size="xl" divider className="w-full">
          {sortByPriority(insights).map((insight) => {
            return (
              <InsightsCard
                key={getInsightKey(insight)}
                {...insight}
                focusArea={focusArea}
                calibrationFraming={calibrationFraming}
                dimensionsPayload={dimensionsPayload}
              />
            );
          })}
        </Spacing>
      )}
    </Spacing>
  );
};
